import { render, staticRenderFns } from "./projectODM.vue?vue&type=template&id=06dd8b5a&"
import script from "./projectODM.vue?vue&type=script&lang=ts&"
export * from "./projectODM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports